import React from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";

export default function CategoryHasMilestoneModal({ hide, userData, ...props }) {

  const Footer = () => {
    return (
      <div className="relative flex flex-row items-center justify-end space-x-2">
        <Button
          key="cancel-btn-category"
          buttonName="Close"
          buttonClass="bg-thBg py-3 px-9"
          buttonTextClass="text-black text-sm font-bold"
          onClick={() => hide()}
        />
      </div>
    );
  };

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-8/20 1xl:w-6/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-mutedGray"
    >
      <div className="w-full">
        {/* header */}
        <ModalHeader title="Delete Category" hide={hide} />
        {/* content */}
        <div className="pl-10 pr-7 py-7">
          <p className="text-lightBlack">
            {props.message}
          </p>
        </div>
      </div>
    </Modal>
  );
}
